import { useContext } from "react";
import { Datas } from "../../App";
import p from '../../styles/Profile.module.css';
import BackHome from "../../components/BackHome";

// IOS Изображения
import photoIos from '../../assets/photo/photoIos.png';
import photoIos2 from '../../assets/photo/photoIos2.png';
import photoIos3 from '../../assets/photo/photoIos3.jpg';
import photoIos4 from '../../assets/photo/photoIos4.png';
import photoIos5 from '../../assets/photo/photoIos5.png';
import photoIos6 from '../../assets/photo/photoIos6.png';
import photoIos7 from '../../assets/photo/photoIos7.png';

function Ios() {
    const data = useContext(Datas);

    const iosSteps = [
        { text: 'Скачайте приложение OneXray из App Store', href: 'https://apps.apple.com/ru/app/onexray/id6745748773', photo: photoIos5 },
        { text: 'Выберите RU', href: null, photo: photoIos },
        { text: 'Разрешите добавление VPN конфигураций', href: null, photo: photoIos2 },
        { text: 'Нажмите на плюс', href: null, photo: photoIos3 },
        { text: 'Выберите подписка', href: null, photo: photoIos4 },
        { text: 'Придумайте имя и вставьте выданную в профиле ссылку', href: null, photo: photoIos6 },
        { text: 'Выберите сервер', href: null, photo: photoIos7 },
    ];

    return (
        <>
            <BackHome />
            <div className={p.page}>
                <div className={p.section}>
                    <p className={p.section_title} style={{ cursor: 'default' }}>
                        Инструкция по настройке iOS:
                    </p>

                    <div className={p.steps}>
                        {iosSteps.map((step, i) => (
                            <div key={i} style={{ display: 'flex', flexDirection: 'column', gap: '8px', width: '100%' }}>
                                <div className={p.step_row}>
                                    <div className={p.step_num}>{i + 1}</div>
                                    <div className={p.step_text}>
                                        {step.href ? (
                                            <a href={step.href} className={p.step_link} target="_blank" rel="noreferrer">
                                                {step.text}
                                            </a>
                                        ) : (
                                            <span>{step.text}</span>
                                        )}
                                    </div>
                                </div>
                                {step.photo && (
                                    <img 
                                        src={step.photo} 
                                        className={p.step_photo} 
                                        alt={`Шаг ${i + 1}`} 
                                        style={{ marginBottom: i !== iosSteps.length - 1 ? '12px' : '0px' }} 
                                    />
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
}

export default Ios;